module.exports = __webpack_public_path__ + "static/media/school_elem.a84137ad.svg";